package com.kinoshazam.model

import kotlinx.serialization.Serializable

@Serializable
data class Features(
    val watchVideo: Boolean = false,
    val registration: Boolean = false,
    val subscription: Boolean = false,
    val taste: Boolean = true,
    val identify: Boolean = false,
)
